import React from 'react';

import loadLogin from 'bundle-loader?lazy&title=Home!./components/routes/login/login.jsx';
import loadRedirect from 'bundle-loader?lazy&title=Slack!./components/routes/redirect/redirect.jsx';
import loadError from 'bundle-loader?lazy&title=Slack!./components/routes/error/error.jsx';
import loadEzThanksPrivacy from 'bundle-loader?lazy&title=PrivacyPolicy!./components/routes/ezthanks/privacy-policy.jsx';
import loadTermsAndConditions from 'bundle-loader?lazy&title=TOC!./components/routes/terms-and-conditions/terms-and-conditions.jsx';
import loadTermsAndConditionsDM from 'bundle-loader?lazy&title=TOC!./components/routes/terms-and-conditions-dm/terms-and-conditions.jsx';
import loadPrivacyPolicy from 'bundle-loader?lazy&title=TOC!./components/routes/privacy-policy/privacy-policy.jsx';

import loadSlackInstall from 'bundle-loader?lazy&title=Slack!./components/routes/slack/install/install.jsx';
import loadSlackInstallComplete from 'bundle-loader?lazy&title=Slack!./components/routes/slack/install-complete/install-complete.jsx';
import loadSlackConnect from 'bundle-loader?lazy&title=Slack!./components/routes/slack/connect/connect.jsx';

import loadTeamsInstall from 'bundle-loader?lazy&title=Teams!./components/routes/teams/install/install.jsx';
import loadChromeInstall from 'bundle-loader?lazy&title=Chrome!./components/routes/chrome/install/install.jsx';

import loadOutlookInstall from 'bundle-loader?lazy&title=Outlook!./components/routes/outlook/install/install.jsx';

const REMOVED_INTEGRATIONS = /^\/(chrome|teams|outlook)(\/|$)/;

const Bundle = ( Component ) => (
    ( props ) => (
        <Component { ...props } />
    )
);

export const routes = [
    {
        title: 'Chrome',
        pattern: '/chrome',
        load: loadChromeInstall,
        showTabs: true
    },
    {
        title: 'Chrome',
        pattern: '/chrome/install',
        load: loadChromeInstall,
        showTabs: true
    },
    {
        title: 'Slack',
        pattern: '/slack',
        load: loadSlackInstall,
        showTabs: false
    },
    {
        title: 'Slack',
        pattern: '/slack/install',
        load: loadSlackInstall,
        showTabs: false
    },
    {
        title: 'Slack',
        pattern: '/slack/install/redirect',
        load: loadRedirect,
        showTabs: false
    },
    {
        title: 'Slack',
        pattern: '/slack/install/login/:oidc?',
        load: loadLogin,
        showTabs: false
    },
    {
        title: 'Slack',
        pattern: '/slack/install/complete',
        load: loadSlackInstallComplete,
        showTabs: false
    },
    {
        title: 'Slack',
        pattern: '/slack/install/error',
        load: loadError,
        showTabs: false
    },
    {
        title: 'Slack',
        pattern: '/slack/connect',
        load: loadSlackConnect,
        showTabs: false
    },
    {
        title: 'Slack',
        pattern: '/slack/connect/error',
        load: loadError,
        showTabs: false
    },
    {
        title: 'Teams',
        pattern: '/teams',
        load: loadTeamsInstall,
        showTabs: true
    },
    {
        title: 'Teams',
        pattern: '/teams/install',
        load: loadTeamsInstall,
        showTabs: true
    },
    {
        title: 'Outlook',
        pattern: '/outlook',
        load: loadOutlookInstall,
        showTabs: true
    },
    {
        title: 'Outlook',
        pattern: '/outlook/install',
        load: loadOutlookInstall,
        showTabs: true
    },
    {
        title: 'Terms & Conditions',
        pattern: '/terms-and-conditions',
        load: loadTermsAndConditions,
        showTabs: false
    },
    {
        title: 'Terms & Conditions',
        pattern: '/terms-and-conditions/:integrationType',
        load: loadTermsAndConditions,
        showTabs: false
    },
    {
        title: 'Terms & Conditions',
        pattern: '/terms-and-conditions-dm',
        load: loadTermsAndConditionsDM,
        showTabs: false
    },
    {
        title: 'Privacy Policy',
        pattern: '/privacy',
        load: loadPrivacyPolicy,
        showTabs: false
    },
    {
        title: 'Privacy Policy',
        pattern: '/privacy/:integrationType',
        load: loadPrivacyPolicy,
        showTabs: false
    },
    {
        title: 'EZ Thanks Privacy Policy',
        pattern: '/ezthanks/privacy',
        load: loadEzThanksPrivacy,
        showTabs: false
    }
];

export const getMiddleware = () => {
    return [
        // navigate to an integration on the root, and send removed integrations to Slack
        ( action, nextRoute, prevRoute ) => {
            if ( nextRoute.pathname === '/' || REMOVED_INTEGRATIONS.test( nextRoute.pathname ) ) {
                action.redirect( '/slack' );
            } else {
                action.ok();
            }
        },
        // Load Bundles
        ( action, nextRoute, prevRoute ) => {
            if ( nextRoute.match && !nextRoute.match.render &&
                typeof nextRoute.match.load === 'function' ) {
                nextRoute.match.load( ( asyncModule ) => {
                    nextRoute.match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
                    action.ok();
                } );
            } else {
                action.ok();
            }
        }
    ];
};
